import React, { Component } from "react";
import { Link } from "react-router-dom";
// import './acciones.css';
import Swal from "sweetalert2";

import eliminar_icono from "../../../../../assets/img/iconos/eliminar-icono.svg";
import editar_icono from "../../../../../assets/img/iconos/editar-icono.svg";

class Acciones extends Component {
    constructor(props) {
        super(props);
    }

    eliminar = (id) => {
        return () => {
            Swal.fire({
                title: "¿Eliminar?",
                text: "¡No podrá revertir esta acción!",
                type: "warning",
                showCancelButton: true,
                confirmButtonText: "¡Sí, eliminar!",
                cancelButtonText: "No, cancelar",
                reverseButtons: true,
            }).then((result) => {
                if (result.value) {
                    this.props.eliminar(id);
                }
            });
        };
    };

    editarModal = (id) => {
        return () => {
            this.props.editarModal(id);
        };
    };

    render() {
        const { id, ver, editar, eliminar, editarModal } = this.props;

        return (
            <div className="d-flex justify-content-center">
                {ver !== undefined && (
                    <Link to={`${ver}/${id}/ver`} className="px-2">
                        <i className="material-icons">remove_red_eye</i>
                    </Link>
                )}
                {editar !== undefined && (
                    <Link
                        className="text-warning"
                        to={`${editar}/${id}/editar`}
                    >
                        <img
                            className="action-img"
                            title="Editar"
                            src={editar_icono}
                            alt="Editar"
                            width="17"
                        />
                    </Link>
                )}
                {editarModal !== undefined && (
                    <a className="text-warning" onClick={this.editarModal(id)}>
                        <img
                            className="action-img"
                            title="Editar"
                            src={editar_icono}
                            alt="Editar"
                            width="17"
                        />
                    </a>
                )}
                {eliminar !== undefined && (
                    <a
                        className="px-2"
                        style={{ cursor: "pointer", color: "#c4183c" }}
                        onClick={this.eliminar(id)}
                    >
                        <img
                            className="action-img"
                            title="Eliminar"
                            src={eliminar_icono}
                            alt="Eliminar"
                            width="17"
                        />
                    </a>
                )}
            </div>
        );
    }
}
Acciones.propTypes = {};

export function standardActions(acciones) {
    return (cell, row) => {
        return <Acciones id={cell} {...acciones} />;
    };
}
